module.exports = __webpack_public_path__ + "static/img/step3_phone_2_1.2f26a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step3_phone_2_1.png
// module id = Pcd0
// module chunks = 1